import { MenuService } from './../../../services/menu.service';
import { TemplatePortalDirective, Portal } from '@angular/cdk/portal';
import { OverlayConfig, Overlay, OverlayOrigin } from '@angular/cdk/overlay';
import { Component, OnInit, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { fadeUp } from '../../../animations/router.animation';
export class MainToolbarLeftMenuComponent implements OnInit {

     menu: OverlayOrigin;
     templatePortals: QueryList<Portal<any>>;
    startMenus = this.menuService.startMenu;
/**
 * @param {?} overlay
 * @param {?} menuService
 */
constructor(
public overlay: Overlay,
private menuService: MenuService,
    ) { }
/**
 * @return {?}
 */
ngOnInit() {
    }
/**
 * @param {?} e
 * @return {?}
 */
clickMenu(e) {
        const /** @type {?} */ config = new OverlayConfig({
            hasBackdrop: true,
            backdropClass: 'menu-overlay-backdrop',
            scrollStrategy: this.overlay.scrollStrategies.block(),
            positionStrategy: this.overlay.position().connectedTo(
                this.menu.elementRef,
                {originX: 'start', originY: 'bottom'},
                {overlayX: 'start', overlayY: 'top'}
            )
        });
        const /** @type {?} */ overlayRef = this.overlay.create(config);
        overlayRef.attach(this.templatePortals.first);
        overlayRef.backdropClick().subscribe(() => {
            overlayRef.dispose();
        });
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'hd-main-toolbar-left-menu',
  template: `
    <ul class="left-menu-list">
        <li class="left-menu-item" (click)="clickMenu($event)" cdk-overlay-origin #mainMenu="cdkOverlayOrigin">
            <a class="left-menu-link">
                <i class="icon flaticon-squares-3"></i>
                <span class="text">
                    Main Menu
                </span>
                <i class="arrow la la-angle-down"></i>
                <!-- <i class="arrow la la-angle-right"></i> -->
            </a>
            <ng-template cdk-portal>
                <div class="left-menu-dropdown" [@fadeUp]="">
                    <span class="arrow"></span>
                    <ul class="left-dropdown-list">
                        <li hd-left-menu-item *ngFor="let menu of startMenus">
                            <a routerLink="/{{menu.path}}" class="left-dropdown-link">
                                <i class="left-dropdown-link-icon">
                                    <img [src]="menu.data.icon">
                                </i>
                                <span class="left-dropdown-link-text">
                                    {{menu.data.title}}
                                </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </ng-template>
        </li>
    </ul>
  `,
  styles: [`
    @media (min-width: 993px) {
      :host {
        width: auto;
        float: left;
        display: table;
        height: 100%;
        margin: 0 0 0 10px;
        font-size: 14px;
        font-weight: 300;
        font-family: "Poppins";
        -webkit-font-smoothing: antialiased; }
      .left-menu-list {
        list-style: none;
        margin: 0;
        padding: 0;
        display: table-row;
        height: 100%;
        font-size: 14px;
        font-weight: 300;
        font-family: "Poppins";
        -webkit-font-smoothing: antialiased; }
        .left-menu-list .left-menu-item {
          position: relative;
          height: 100%;
          display: table-cell;
          vertical-align: middle;
          padding: 0px 10px; }
          .left-menu-list .left-menu-item .left-menu-link {
            padding: 0px;
            display: table;
            position: relative;
            vertical-align: middle;
            height: 100%;
            outline: none !important;
            cursor: pointer;
            text-decoration: none !important; }
            .left-menu-list .left-menu-item .left-menu-link .text {
              color: #676c7b;
              font-weight: 400;
              font-size: 14px;
              text-transform: initial;
              width: auto;
              display: table-cell;
              height: 100%;
              padding: 0;
              vertical-align: middle;
              cursor: pointer; }
            .left-menu-list .left-menu-item .left-menu-link .text:hover {
              color: #214E8D !important; }
            .left-menu-list .left-menu-item .left-menu-link .icon {
              color: #b8bece;
              font-size: 18px;
              width: 30px;
              text-align: left;
              padding: 0;
              line-height: 0;
              display: table-cell;
              vertical-align: middle;
              cursor: pointer; }
            .left-menu-list .left-menu-item .left-menu-link .arrow {
              color: #b9c1d4;
              font-size: 14px;
              width: 25px;
              text-align: right;
              vertical-align: middle;
              display: table-cell; }
            .left-menu-list .left-menu-item .left-menu-link .arrow:hover {
              color: #214E8D !important; } }
  `],
  animations: [
        fadeUp()
  ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Overlay, },
{type: MenuService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'menu': [{ type: ViewChild, args: ['mainMenu', ] },],
'templatePortals': [{ type: ViewChildren, args: [TemplatePortalDirective, ] },],
};
}

function MainToolbarLeftMenuComponent_tsickle_Closure_declarations() {
/** @type {?} */
MainToolbarLeftMenuComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
MainToolbarLeftMenuComponent.ctorParameters;
/** @type {?} */
MainToolbarLeftMenuComponent.propDecorators;
/** @type {?} */
MainToolbarLeftMenuComponent.prototype.menu;
/** @type {?} */
MainToolbarLeftMenuComponent.prototype.templatePortals;
/** @type {?} */
MainToolbarLeftMenuComponent.prototype.startMenus;
/** @type {?} */
MainToolbarLeftMenuComponent.prototype.overlay;
/** @type {?} */
MainToolbarLeftMenuComponent.prototype.menuService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
